import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MyErrorHandler } from 'src/app/constants/error';
import { ModalErrorComponent } from 'src/app/modal/modal-gestioneErrori/modal-error/modal-error.component';
import { ModalSuccessComponent } from 'src/app/modal/modal-gestioneErrori/modal-success/modal-success.component';
import { ROUTES } from 'src/app/route/routes';
import {Event, EventCategory, EventDate, EventGroup, OpeningMode, Ship, TimeType} from 'src/app/model';
import { EventService } from 'src/app/services/event.service';
import { EventSlotsModalComponent } from '../../../modal/modal-event/event-slots-modal/event-slots-modal.component';
import * as moment from 'moment';
import { MY_FORMATS } from 'src/app/constants/datapicker';
import { environment } from 'src/environments/environment';
import { SpinnerService } from 'src/app/_components/spinner/spinner.service';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { TIMERELATIVEOPTIONS, TIMETYPEOPTIONS } from 'src/app/constants/times';
import {UserService} from "../../../services/user.service";

@Component({
  selector: 'app-event-new',
  templateUrl: './event-new.component.html',
  styleUrls: ['./event-new.component.scss'],
  standalone: false
})
export class EventNewComponent implements OnInit {
  maxPerPassengerReservableLabel: number =
    environment.constantMaxReservationsPerEvent;

  myControl = new FormControl();

  optionsRelativeTime: Array<TimeType> = TIMERELATIVEOPTIONS;
  selectedTimeRelativeChiusura: TimeType = TIMERELATIVEOPTIONS[0];
  selectedTimeRelativeChiusuraWL: TimeType = TIMERELATIVEOPTIONS[0];

  optionsTypeTime: Array<TimeType> = TIMETYPEOPTIONS;
  selectedTimeTypeApertura: TimeType = TIMETYPEOPTIONS[0];
  selectedTimeTypeChiusura: TimeType = TIMETYPEOPTIONS[0];
  selectedTimeTypeChiusuraWL: TimeType = TIMETYPEOPTIONS[0];

  filteredOptions!: Observable<string[]>;
  selectedLangTitle: string = 'en';
  selectedLangShort: string = 'en';
  selectedLangLong: string = 'en';
  eventModel: Event = new Event();
  group: EventGroup = new EventGroup("");
  listCategory: Array<EventCategory> = [];
  listShips: Array<Ship> = [];
  minDate = new Date();
  openingModeEnum = OpeningMode;
  selectedMode: OpeningMode | undefined = OpeningMode.FIRST_OCCURRENCE;
  date: Date | undefined= new Date();

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private eventService: EventService,
    private userService: UserService,
    private spinner: SpinnerService,
  ) {
    this.minDate.setHours(0, 0, 0, 0);
  }

  ngOnInit(): void {
    this.spinner.show();
    this.getAllCategories();
    this.getAvailableShips();
    if (this.listShips.length === 1) {
      this.eventModel.fk_ship = this.listShips[0].id_ship
    }
    // this.getAllLocations();
    // this.filteredOptions = this.myControl.valueChanges.pipe(
    //   // startWith(''),
    //   map(value => this._filter(value)),
    // );
  }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.options.filter(option => option.toLowerCase().includes(filterValue));
  // }

  // getAllLocations() {
  //   this.eventService.getLocations().subscribe({
  //     next: (res) => {
  //       console.log(res);
  //       this.options = res;
  //       this.spinner.hide();
  //     },
  //     error: (err) => {
  //       this.spinner.hide();
  //     }
  //   });
  // }

  getAllCategories() {
    this.eventService.getAllCategories().subscribe({
      next: (res) => {
        this.listCategory = res;
        this.spinner.hide();
      },
      error: _  => this.spinner.hide(),
    });
  }

  isFluxSpa(category: string): boolean {
    if (!category) return false;

    const foundCategory = this.listCategory.find(
      (cat) => cat.id_event_category.toString() == category
    );

    return !!foundCategory && foundCategory.flux == 'spa';
  }

  addGroup(elm: EventGroup) {
    if (elm && elm.id_group.length >=3 && elm.id_group.length <= 50) {
      let existGroup = this.eventModel.event_groups?.find((group) => {
        return group.id_group == elm.id_group;
      });
      if (!existGroup) {
        this.eventModel.event_groups?.push({
          id_group: elm.id_group,
        });
      }
      elm.id_group = '';
    }
  }

  addDate(elm: Date | undefined) {
    if (elm) {
      const newMomentDate = moment(elm, MY_FORMATS.parse.dateInput).startOf('day');
      const existDate = this.eventModel.event_dates?.find(event => {
        return moment(event.date).isSame(newMomentDate, 'day');
      });
      if (!existDate) {
        let eventDate: EventDate = new EventDate();
        eventDate.date = newMomentDate.toDate();
        this.eventModel.event_dates = [...this.eventModel.event_dates!, eventDate];
      }
    }
    this.date = undefined;
  }

  removeGroup(index: number) {
    this.eventModel.event_groups?.splice(index, 1);
  }

  removeDate(dateToRemove: EventDate) {
    this.eventModel.event_dates = this.eventModel.event_dates?.filter(
      eventDate => eventDate !== dateToRemove
    );
  }

  goTo(path: string) {
    switch (path) {
      case 'home':
        this.router.navigate([ROUTES.HOME.path]);
        break;
      case 'landing':
        this.router.navigate([ROUTES.EVENT.path]);
        break;
      case 'here':
        this.router.navigate([ROUTES.EVENT_NEW.path]);
        break;
    }
  }

  openSettingsSlots(event_date: EventDate, isSpaCategory: boolean) {
    const dialogRef = this.dialog.open(EventSlotsModalComponent, {
      data: {
        inputSlots: event_date.event_slots,
        isSpaCategory: isSpaCategory,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        event_date.event_slots = result;
      }
    });
  }

  isValidEventDates() {
    if (!this.eventModel.event_dates || this.eventModel.event_dates.length == 0)
      return false;
    let isValid = true;
    let eventDates: EventDate[] = this.eventModel.event_dates;
    eventDates.forEach((eventDate) => {
      if (isValid) {
        if (
          !eventDate.date ||
          (<Date>eventDate.date).getTime() < this.minDate.getTime() ||
          !eventDate.event_slots ||
          eventDate.event_slots.length == 0
        ) {
          isValid = false;
        }
      }
    });
    return isValid;
  }

  requiredLangs(): boolean {
    return (
      this.eventModel.event_name_en != undefined &&
      this.eventModel.event_name_en.length > 0 &&
      this.eventModel.event_short_description_en != undefined &&
      this.eventModel.event_short_description_en.length > 0 &&
      this.eventModel.event_long_description_en != undefined &&
      this.eventModel.event_long_description_en.length > 0
    );
  }

  isSaveDisabled(): boolean {
    return !this.isValidEventDates();
  }

  save(myForm: HTMLFormElement) {
    if (!myForm.checkValidity() || this.isSaveDisabled()) return;
    this.spinner.show();
    // COMMENTATO PERCHé IL CLIENTE NON VUOLE PIU' LA LOCATION
    // this.eventModel.event_location = this.myControl.value;

    if (!this.isFluxSpa(this.eventModel.fk_event_category?.toString() || '')) {
      const dates = this.eventModel.event_dates
        ? this.eventModel.event_dates
        : [];
      dates.forEach((date) => {
        if (date?.event_slots) {
          date.event_slots.forEach((slot) => {
            if (!slot.detail) {
              slot.detail = '';
            }
          });
        }
      });
    }

    let body: Event = this.eventModel.convertToBE(
      this.selectedTimeRelativeChiusura,
      this.selectedTimeRelativeChiusuraWL,
      this.selectedTimeTypeApertura,
      this.selectedTimeTypeChiusura,
      this.selectedTimeTypeChiusuraWL,
      this.selectedMode!,
    );

    this.eventService.createSingleEvent(body).subscribe({
      next: () => {
        let message = 'Evento creato con successo';
        this.showSuccess(message);
      },
      error: (err) => {
        this.showError(err);
      },
    });
  }

  computeMaxClosing(): number {
    // se la chiusura è prima dell'inizio, deve avvenire dopo l'apertura
    if (this.selectedTimeRelativeChiusura.code == 0) {
      return this.eventModel.time_reservable_before_slot
        ? this.eventModel.time_reservable_before_slot - 1
        : 0;
    } else {
      // se la chiusura è dopo l'inizio dell'evento, può avvenire fino a 1gg dopo
      return 24; // 1 gg
    }
  }

  computeMaxWL(): number {
    let res: number = 0;
    if (this.eventModel.event_dates) {
      for (let o of this.eventModel.event_dates) {
        if (o.event_slots) {
          for (let e of o.event_slots) {
            res = res + e.max_users!;
          }
        }
      }
    }
    return res;
  }

  private showSuccess(message?: string) {
    this.spinner.hide();
    const dialogRef = this.dialog.open(ModalSuccessComponent, {
      data: message,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.goTo('landing');
    });
  }

  private showError(err: any) {
    this.spinner.hide();
    const dialogRef = this.dialog.open(ModalErrorComponent, {
      data: MyErrorHandler.getText(err),
    });

    dialogRef.afterClosed().subscribe(() => {
      this.goTo('here');
    });
  }

  getAvailableShips() {
    this.listShips = this.userService.ships ? this.userService.ships : [];
  }

}
